
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable react/button-has-type */

import React from 'react';
import './requisition.css';
import PropTypes from 'prop-types';
import sharedHelpers from '../../../../../../../utils/helpers';
import {
  ACCOUNTS,
  ADMIN,
  ADMIN_DEPARTMENT,
  CUSTOMER_SUPPORT,
  EXPRESS_WIFI,
  NEW_PRODUCTS,
  NOC,
  OPERATIONS,
  PROCUREMENT,
  RESEARCH_AND_DEVELOPMENT,
  SALES,
  VP_FIBER,
} from '../../../../../../../utils/departments/helpers';
import {
  ASSET_TEAM,
  BUSINESS_DEVELOPMENT,
  PARTNERSHIP,
} from '../../../../../../../utils/config';

const department = new Map([
  [`${ACCOUNTS}`, 'Accounts'],
  [`${ADMIN}`, 'ADMIN'],
  [`${ADMIN_DEPARTMENT}`, 'ADMIN_DEPARTMENT'],
  [`${CUSTOMER_SUPPORT}`, 'CUSTOMER SUPPORT'],
  [`${EXPRESS_WIFI}`, 'EXPRESS WIFI'],
  [`${NEW_PRODUCTS}`, 'NEW PRODUCTS'],
  [`${VP_FIBER}`, 'VP FIBER'],
  [`${NOC}`, 'NOC'],
  [`${OPERATIONS}`, 'OPERATIONS'],
  [`${PROCUREMENT}`, 'PROCUREMENT'],
  [`${RESEARCH_AND_DEVELOPMENT}`, 'RESEARCH AND DEVELOPMENT'],
  [`${SALES}`, 'SALES'],
  [`${BUSINESS_DEVELOPMENT}`, 'BUSINESS DEVELOPMENT'],
  [`${ASSET_TEAM}`, 'ASSET TEAM'],
  [`${PARTNERSHIP}`, 'PARTNERSHIP'],
]);
function getDepartment(id) {
  return department.get(id) || 'null';
}

const DownloadRequisitions = ({ requistions }) => {
  // const requistions = [];
  const handleDownload = () => {
    // const downloadUrls = requistions.map((a) => a.imageUpload);
    // eslint-disable-next-line func-names
    // downloadUrls.forEach(function(value) {
    //   window.open(value, '_blank');
    // });
  };

  function convertToCSV(objArray) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < array.length; i++) {
      let line = '';

      for (const index in array[i]) {
        if (line !== '') line += ',';

        line += array[i][index];
      }

      str += `${line}\r\n`;
    }

    return str;
  }

  function exportCSVFile(headers, items, fileTitle) {
    if (headers) {
      items.unshift(headers);
    }

    // Convert Object to JSON
    const jsonObject = JSON.stringify(items);

    const csv = convertToCSV(jsonObject);

    const exportedFilenmae = `${fileTitle}.csv` || 'export.csv';

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
      const link = document.createElement('a');

      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', exportedFilenmae);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const download = () => {
    const headers = {
      purpose: 'Purpose',
      amountInWords: 'Amount In Words',
      date: 'Created At',
      department: 'Department',
      inFavourOf: 'In Favour Of',
      amountInDigits: 'Amount In Digits',
      currency: 'Currency',
      file1: 'File 1',
      file2: 'File 2',
      file3: 'File 3',
      file4: 'File 4',
      file5: 'File 5',
      file6: 'File 6',
      managerApproal: 'Manager Approval',
      accountApproval: 'Acount Approval',
      country: 'Country',
      accountPaymentStatus: 'Acount Payment Status',
    };

    const newData = [];

    // format the data
    requistions.forEach((item) => {
      newData.push({
        purpose: item.purpose.replace(/[^a-zA-Z ]/g, ''),
        amountInWords: item.amount_in_words.replace(/,/g, ''),
        date: item.created_at,
        department: getDepartment(item.department_id),
        inFavourOf: item.in_favour_of,
        amountInDigits: item.amount_in_digits,
        currency: item.currency,
        file1: item.imageUpload,
        file2: item.image2,
        file3: item.image3,
        file4: item.image4,
        file5: item.image5,
        file6: item.image6,
        managerApproal: item.manager_approval,
        accountApproval: item.account_approval,
        country: item.country,
        accountPaymentStatus: item.account_payment_status,
        // budgetCode: item.budget_code,
      });
    });

    const fileTitle = 'requsitions';
    exportCSVFile(headers, newData, fileTitle);
  };

  return (
    <button onClick={download} className="downloadButton">
      Download
    </button>
  );
};

DownloadRequisitions.propTypes = {
  // eslint-disable-next-line react/require-default-props
  requistions: PropTypes.shape(),
};

export default DownloadRequisitions;

